
Greenmile.Event = Greenmile.Event || {};

Greenmile.Event.SelectFieldList = function () {

    this.fieldList = {};

    this.elFieldList = document.createElement('div');
    this.elFieldList.className = 'MonetUIFilterBuilderSelectContainer EventsManage';
    this.clickListeners = [];

    this.setAvailableTags = function(availableTags) {
        availableTags.forEach ((item) => {
            item.value = `@${item.value}@`;
            this.fieldList[item.value] = item;
        });
    }

    this.addClickEventListener = function (callback) {
        this.clickListeners.push(callback);
    };

    this.notifyClickEvent = function (field) {
        this.clickListeners.forEach((item) => {
            item(field);
        });

        this.clear();
    }.bind(this);

    this.getSelectedField = function () {
        return this.value;
    };

    this.getSelectPicker = () => ( $(this.elFieldList.querySelector('select.pickListFieldFilters')) ) ;

    this.setValueOnPickList = (value) => {
        var selectPicker = this.getSelectPicker();
        selectPicker.selectpicker('val', value);
        selectPicker.selectpicker('refresh');
    };

    this.setSelectedField = function (field) {
        this.value = field;
        this.setValueOnPickList(field.value);
        this.notifyClickEvent(field);
    };

    this.clear = () => ( this.setValueOnPickList("default") );

    this.createOptionField = function (field) {
        var translated = Monet.I18n.getResourcesByKey(field.label);
        var option = document.createElement('option');
        option.setAttribute('value', field.value);
        option.setAttribute('label', translated);
        option.innerHTML = translated;
        return option;
    };

    this.renderFieldList = function () {

        var fragment = document.createDocumentFragment();
        var select = document.createElement('select');
        select.className = 'pickListFieldFilters';
        select.setAttribute('data-live-search', 'true');
        select.setAttribute('title', Monet.I18n.getResourcesByKey("event.button.add.bubble"));

        if (this.fieldList.length === 0) {
            select.appendChild(this.createOptionField({ value: '', label: Monet.I18n.getResourcesByKey("event.attributesList.empty")}));
        }

        for (var field in this.fieldList) {
            select.appendChild(this.createOptionField(this.fieldList[field]));
        }
        fragment.appendChild(select);

        return fragment;

    };

    this.createList = function () {

        if (this.beforeCreateList) {
            this.beforeCreateList(this.fieldList);
        }

        this.elFieldList.appendChild(this.renderFieldList());

        var pickList = $(this.elFieldList.querySelector('.pickListFieldFilters'));
        pickList.selectpicker({
            size: 7,
            callback: function (val) {
                var field = this.fieldList[val];
                if (field) {
                    this.value = field;
                } else {
                    this.value = '';
                }
                this.notifyClickEvent(field);
            }.bind(this),
            liveSearchNormalize: true
        });

        pickList.selectpicker('refresh');
        pickList.selectpicker('show');
    };

    this.render = function () {

        this.createList();

        return this.elFieldList;

    };

};